// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__9AiQq","text":"styles_text__2D42H"};